<template>
  <div class="flex space-x-2 overflow-x-hidden">
    <button
      v-if="showThumbsUp"
      @click="submitFeedback('thumbs_up')"
      class="text-gray-500 hover:text-green-500 transition-colors p-1 rounded-full hover:bg-gray-100"
      title="Thumbs up">
      <font-awesome-icon :icon="['fas', 'thumbs-up']" />
    </button>

    <button
      v-if="showThumbsDown"
      @click="submitFeedback('thumbs_down')"
      class="text-gray-500 hover:text-red-500 transition-colors p-1 rounded-full hover:bg-gray-100"
      title="Thumbs down">
      <font-awesome-icon :icon="['fas', 'thumbs-down']" />
    </button>

    <button
      v-if="showIsDuplicate"
      @click="submitFeedback('is_duplicate')"
      class="text-gray-500 hover:text-blue-500 transition-colors p-1 rounded-full hover:bg-gray-100"
      title="Is duplicate">
      <font-awesome-icon :icon="['fas', 'repeat']" />
    </button>

    <button
      v-if="showDelete"
      @click="isOpenDeleteObjectModal=true"
      class="text-gray-500 hover:text-red-500 transition-colors p-1 rounded-full hover:bg-gray-100"
      title="Delete">
      <font-awesome-icon :icon="['fas', 'trash-can']" />
    </button>
  </div>

  <!-- Delete Confirmation Modal -->
  <ConfirmationModal
    :is-visible="isOpenDeleteObjectModal"
    @cancel="isOpenDeleteObjectModal = false"
    @confirm="deleteSuggestion"
    :message="'Are you sure you want to delete this suggestion?'"
  />

</template>

<script>
import axios from 'axios';
import ConfirmationModal from "@/components/widgetcomponents/ConfirmationModal.vue";

export default {
  name: 'LlmSuggestionFeedback',
  components: {ConfirmationModal},
  props: {
    relatedObjectId: {
      type: [String, Number],
      required: true
    },
    relatedObjectContentTypeModel: {
      type: String,
      required: true
    },
    showThumbsUp: {
      type: Boolean,
      default: false
    },
    showThumbsDown: {
      type: Boolean,
      default: false
    },
    showIsDuplicate: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete', 'feedback-submitted'],
  data() {
    return {
      isOpenDeleteObjectModal: false,
      deleteObjectId: null,
    };
  },
  methods: {
    async deleteSuggestion() {
      try {
        const endpoint = `api/llmsuggestions/${this.relatedObjectId}/`;
        await axios.delete(endpoint);

        this.isOpenDeleteObjectModal = false;
        this.deleteObjectId = null;
        this.$emit('delete', this.relatedObjectId);
      } catch (error) {
        console.error('Error deleting suggestion', error);
      }
    },
    async submitFeedback(feedbackType) {
      try {
        const response = await axios.post('api/llmsuggestionfeedback/addfeedback/', {
          related_object_id: this.relatedObjectId,
          related_object_content_type_model: this.relatedObjectContentTypeModel,
          is_useful : feedbackType === 'thumbs_up' ? 1 : 0,
          is_not_useful : feedbackType === 'thumbs_down' ? 1 : 0,
          is_duplicate: feedbackType === 'is_duplicate' ? 1 : 0
        });

        this.$emit('feedback-submitted', {
          type: feedbackType,
          success: true,
          response: response.data
        });
      } catch (error) {
        console.error('Error submitting feedback:', error);
        this.$emit('feedback-submitted', {
          type: feedbackType,
          success: false,
          error: error
        });
      }
    }
  }
}
</script>
